import { commonService } from '.';

const update = (id, body) => {
    return commonService.post('OtherActionsNextYear?id=' + id, body);
};

const insert = (body) => {
    return commonService.post('OtherActionsNextYear', body);
};

const deleteOtherActionsNextYear = (id, idEa) => {
    return commonService.deleteWithParam('OtherActionsNextYear?id=' + id + '&idEa=' + idEa, null);
};

const getByIdEa = (idEa) => {
    return commonService.getWithParam('OtherActionsNextYear/getByIdEa?idEa=' + idEa, null);
};

export const otherActionsNextYearService = {
    update,
    insert,
    deleteOtherActionsNextYear,
    getByIdEa
};